const coreIAMUrl = process.env.VUE_APP_CORE_IAM_URL;

export default coreIAMUrl;
